export default __webpack_public_path__ + "static/media/property_766.937fe31c.png";